import React from "react";
import { VENDOR_AGREEMENT_SECTIONS } from "./constants";

/**
 * Step 4: legal agreement acknowledgment and electronic signature.
 */
const VendorOnboardingStepSignature = ({
  agreementAccepted,
  setAgreementAccepted,
  handleUndo,
  handleClear,
  handleCompleteOnboarding,
  onBack,
}) => (
  <div className="col-md-12">
    <div className="bg-light rounded-3 p-3 mb-3">
      <h4 className="h5 mb-1">Acknowledgment & Signature</h4>
      <p className="small text-muted mb-3">
        Please review the agreement below. You must accept the terms and
        provide a signature to complete vendor onboarding.
      </p>

      <div className="bg-white border rounded-3 p-3 mb-3">
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
          <div>
            <h5 className="mb-1">
              Vendor Advertising Agreement and Terms of Service
            </h5>
            <div className="small text-muted">BrokerAgentBase.com</div>
          </div>
          <span className="badge bg-info text-dark">
            Effective Date: {new Date().toLocaleDateString()}
          </span>
        </div>

        <div
          className="border rounded-3 p-3"
          style={{
            maxHeight: 340,
            overflowY: "auto",
            background: "#fcfcfe",
          }}
        >
          <p className="small mb-3">
            This Vendor Advertising Agreement and Terms of Service
            (&quot;Agreement&quot;) is a legally binding agreement between
            BrokerAgentBase.com (&quot;Company&quot;), used by In Depth Realty,
            a Utah licensed real estate brokerage, and the vendor
            (&quot;Vendor&quot;). By accessing the platform, creating an
            account, purchasing advertising, or submitting content, Vendor
            agrees to be bound by this Agreement.
          </p>

          {VENDOR_AGREEMENT_SECTIONS.map((section) => (
            <div key={section.title} className="mb-3">
              <h6 className="mb-2">{section.title}</h6>
              {section.paragraphs?.map((p) => (
                <p key={p} className="small mb-2">
                  {p}
                </p>
              ))}
              {section.bullets?.length ? (
                <ul className="small mb-2 ps-3">
                  {section.bullets.map((b) => (
                    <li key={b} className="mb-1">
                      {b}
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          ))}
        </div>

        <div className="form-check mt-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="vendor-terms-accept"
            checked={agreementAccepted}
            onChange={(e) => setAgreementAccepted(e.target.checked)}
          />
          <label
            className="form-check-label small"
            htmlFor="vendor-terms-accept"
          >
            I have read, understood, and agree to the Vendor Advertising
            Agreement and Terms of Service. I confirm I have authority to bind
            my business to these terms.
          </label>
        </div>
      </div>

      <h6 className="mb-2">Signature</h6>
      <p className="small text-muted mb-2">
        Use a touch screen or your mouse to sign below as your electronic
        acceptance.
      </p>
      <div id="signature-pad" className="border rounded bg-white">
        <canvas
          className="signature-canvas w-100"
          style={{ minHeight: 180 }}
        />
      </div>
      <div className="mt-2 mb-3">
        <button
          type="button"
          className="btn btn-secondary btn-sm me-2"
          onClick={handleUndo}
        >
          <i className="fa fa-undo me-1" aria-hidden="true"></i>
          Undo
        </button>
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          onClick={handleClear}
        >
          <i className="fa fa-eraser me-1" aria-hidden="true"></i>
          Clear
        </button>
      </div>
      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-stretch align-items-sm-center gap-3 mt-4 pt-3 border-top w-100">
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={onBack}
        >
          Back
        </button>
        <button
          type="button"
          className="btn btn-primary btn-sm align-self-sm-end"
          onClick={handleCompleteOnboarding}
        >
          Complete onboarding
          <i className="fi-chevron-right fs-sm ms-2"></i>
        </button>
      </div>
    </div>
  </div>
);

export default VendorOnboardingStepSignature;
